export default __webpack_public_path__ + "static/ogimage-5566785639db222c0b41bffb48f72d35.png";